import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Config from "config";
import { map } from "lodash";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  CardTitle,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import HmPaginated from "components/Common/hmPaginated";
import DeleteButton from "./DeleteButtonShow";
const backUrl = Config.backOffice.url;
const DocumentFusion = ({
  Titre,
  loading,
  setLoading,
  sauvegardesAttestationData,
  activeTab,
  handleAction,
  handleTabClick,
  fetchData,
  CustomNavTabs,
  id,
  api,
  signature,
  wait,

  // Function to fetch data
}) => {
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const token = localStorage.getItem("auth_token_" + api);
  const renderValue = (value) => {
    if (value == null) {
      return "";
    } else if (typeof value === "string" && value.trim() === "") {
      return "";
    } else if (value === "Validé") {
      return <span className="bg-success badge bg-secondary">{value}</span>;
    } else if (value === "En attente") {
      return <span className="bg-info badge bg-secondary">{value}</span>;
    } else {
      return value;
    }
  };
  const [modal, setModal] = useState(false);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  const [printDone, setPrintDone] = useState(false);
  const toggleModal = () => setModal(!modal);
  const navigate = useNavigate();
  useEffect(() => {
    // Fetch data or any other side effect when component mounts
    fetchData();
  }, [signature, printDone]);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "print_one":
        toast.success("Impression en cours ...", { autoClose: 20000 });
        console.log(
          `https://www.fluxod.com/${api}/impressions/${action.action}?impression_id=${sauvegardesAttestationData?.detail_sauvegardes_attestation?.ids.impression_id}&sauvegardes_attestation_id=${id}`
        );

        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/impressions/${action.action}?impression_id=${sauvegardesAttestationData?.detail_sauvegardes_attestation?.ids.impression_id}&sauvegardes_attestation_id=${id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = await response.json();
          if (response.status == 200) {
            toast.success(data.message);
            if (!data.message.includes("Echec")) {
              setTimeout(() => {
                navigate(
                  `${backUrl}/impressions/${sauvegardesAttestationData?.detail_sauvegardes_attestation?.ids.impression_id}`
                );
              }, 2000);
            }
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;
      case "valider_a_non":
        toast.success("Rejet en cours ...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${action.params.impression_id}/${action.action}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const impression = await response.json();
          if (response.status == 200) {
            toast.success(impression.message);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        // navigate(
        //   `${backUrl}/${action.controlleur}/${action.action}/${action.params.investisseur_id}`
        // );
        break;
      case "print_all":
        toast.success("Impression en cours...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${action.params.impression_id}/${action.action}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const impression = await response.json();
          if (response.status == 200) {
            toast.success(impression.message);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;

      case "supprimer_docs":
        toggle();
        setData(action);

        break;

      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        {Titre}
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        sauvegardesAttestationData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {sauvegardesAttestationData?.can_edit ? (
                        <Link
                          to={`${backUrl}/${api}/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {sauvegardesAttestationData?.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/sauvegardes_attestations/${id}`}
                        />
                      ) : null}
                      {sauvegardesAttestationData?.actions?.length > 0 ? (
                        <>
                          <>
                            &nbsp; &nbsp;
                            <Dropdown
                              isOpen={btnsecondary1}
                              toggle={() => setBtnsecondary1(!btnsecondary1)}
                            >
                              <DropdownToggle
                                tag="button"
                                className="btn btn-sm btn-secondary"
                              >
                                Actions <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {sauvegardesAttestationData?.actions.map(
                                  (value, index) => (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          handleDropDownActionsClick(
                                            value.action
                                          )
                                        }
                                      >
                                        {value.label}
                                      </DropdownItem>
                                    </>
                                  )
                                )}
                              </DropdownMenu>
                            </Dropdown>
                          </>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {sauvegardesAttestationData
                                ?.detail_sauvegardes_attestation
                                ?.Attestation ? (
                                <IdentificationCard
                                  title="Attestation"
                                  ids={
                                    sauvegardesAttestationData
                                      ?.detail_sauvegardes_attestation?.ids
                                  }
                                  details={
                                    sauvegardesAttestationData
                                      ?.detail_sauvegardes_attestation
                                      ?.Attestation
                                  }
                                />
                              ) : null}
                            </Col>
                            <Col sm="6">
                              {sauvegardesAttestationData
                                ?.detail_sauvegardes_attestation
                                ?.Investissement ? (
                                <SouscriptionsCard
                                  title="Investissement"
                                  ids={
                                    sauvegardesAttestationData
                                      ?.detail_sauvegardes_attestation?.ids
                                  }
                                  details={
                                    sauvegardesAttestationData
                                      ?.detail_sauvegardes_attestation
                                      ?.Investissement
                                  }
                                />
                              ) : null}
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Card>
                                <CardBody>
                                  <CardTitle className="mb-3">
                                    Signature
                                  </CardTitle>
                                  <div className="table-responsive">
                                    <Table className="table-nowrap align-middle table-hover mb-0">
                                      <tbody>
                                        <tr key={"_file_"}>
                                          <td style={{ width: "45px" }}>
                                            <div className="avatar-sm">
                                              <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                <i className="bx bxs-file-doc" />
                                              </span>
                                            </div>
                                          </td>
                                          <td>
                                            <h5 className="font-size-14 mb-1">
                                              <a
                                                href={
                                                  sauvegardesAttestationData
                                                    ?.detail_sauvegardes_attestation
                                                    ?.Signature?.Signature
                                                    .fichier
                                                }
                                                className="text-dark"
                                                style={{
                                                  whiteSpace: "pretty",
                                                }}
                                                download
                                              >
                                                {
                                                  sauvegardesAttestationData
                                                    ?.detail_sauvegardes_attestation
                                                    ?.Signature?.Signature.titre
                                                }
                                              </a>
                                            </h5>
                                            {sauvegardesAttestationData
                                              ?.detail_sauvegardes_attestation
                                              ?.Signature?.Signature.action
                                              ?.action ? (
                                              <button
                                                className=" btn-sm btn-rounded btn"
                                                style={{
                                                  backgroundColor: "#555B21",
                                                  color: "white",
                                                }}
                                                onClick={toggleModal}
                                              >
                                                {
                                                  sauvegardesAttestationData
                                                    ?.detail_sauvegardes_attestation
                                                    ?.Signature?.Signature
                                                    .action?.text
                                                }{" "}
                                                {sauvegardesAttestationData
                                                  ?.detail_sauvegardes_attestation
                                                  ?.Signature?.Signature.action
                                                  ?.action ? (
                                                  <i className="bx bx-pencil " />
                                                ) : null}
                                              </button>
                                            ) : sauvegardesAttestationData
                                                ?.detail_sauvegardes_attestation
                                                ?.Signature?.Signature.action
                                                ?.text ? (
                                              <>
                                                {
                                                  sauvegardesAttestationData
                                                    ?.detail_sauvegardes_attestation
                                                    ?.Signature?.Signature
                                                    .action?.text
                                                }{" "}
                                                {sauvegardesAttestationData
                                                  ?.detail_sauvegardes_attestation
                                                  ?.Signature?.Signature.action
                                                  ?.action ? (
                                                  <i className="bx bx-pencil " />
                                                ) : null}
                                              </>
                                            ) : null}
                                            <p> </p>
                                          </td>
                                          <td>
                                            <div className="text-center">
                                              {sauvegardesAttestationData
                                                ?.detail_sauvegardes_attestation
                                                ?.Signature?.Signature
                                                .fichier && (
                                                <a
                                                  href={
                                                    sauvegardesAttestationData
                                                      ?.detail_sauvegardes_attestation
                                                      ?.Signature?.Signature
                                                      .fichier
                                                  }
                                                  className="text-dark"
                                                  download
                                                >
                                                  <i className="bx bx-download h3 m-0" />
                                                </a>
                                              )}
                                              {sauvegardesAttestationData
                                                ?.detail_sauvegardes_attestation
                                                ?.Signature?.Signature
                                                .fichier &&
                                                sauvegardesAttestationData
                                                  ?.detail_sauvegardes_attestation
                                                  ?.Signature?.Signature
                                                  .action && (
                                                  <Modal
                                                    isOpen={modal}
                                                    toggle={toggleModal}
                                                  >
                                                    <ModalHeader
                                                      toggle={toggleModal}
                                                    >
                                                      Action
                                                    </ModalHeader>
                                                    <ModalBody>
                                                      <p>
                                                        {
                                                          sauvegardesAttestationData
                                                            ?.detail_sauvegardes_attestation
                                                            ?.Signature
                                                            ?.Signature.action
                                                            .confirm
                                                        }
                                                      </p>
                                                    </ModalBody>
                                                    <ModalFooter>
                                                      <Button
                                                        style={{
                                                          backgroundColor:
                                                            "#555B21",
                                                        }}
                                                        onClick={() => {
                                                          toggleModal();
                                                          handleAction(
                                                            sauvegardesAttestationData
                                                              ?.detail_sauvegardes_attestation
                                                              ?.Signature
                                                              ?.Signature.action
                                                          );
                                                        }}
                                                      >
                                                        Valider
                                                      </Button>
                                                      <Button
                                                        color="secondary"
                                                        onClick={toggleModal}
                                                      >
                                                        Fermer
                                                      </Button>
                                                    </ModalFooter>
                                                  </Modal>
                                                )}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </div>
                                  {sauvegardesAttestationData
                                    ?.detail_sauvegardes_attestation
                                    ?.Signature ? (
                                    Object.entries(
                                      sauvegardesAttestationData
                                        ?.detail_sauvegardes_attestation
                                        ?.Signature
                                    ).map(([key, value], index) =>
                                      key != "Signature" ? (
                                        <>
                                          <Row key={index} className="mb-3">
                                            <Col
                                              className="col-4"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {key} :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              className="col-8"
                                              style={{ textAlign: "right" }}
                                            >
                                              <span
                                                style={{
                                                  paddingInlineStart: "8em",
                                                  whiteSpace: "pretty",
                                                  fontFamily: "sans-serif",
                                                }}
                                              >
                                                {key.includes("€") ? (
                                                  renderValue(
                                                    value
                                                  ).toLocaleString("fr-FR", {
                                                    style: "currency",
                                                    currency: "EUR",
                                                  })
                                                ) : key.includes("%") ? (
                                                  renderValue(
                                                    value
                                                  ).toLocaleString("fr-FR", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }) + " %"
                                                ) : key == "Fichier" ? (
                                                  <a href={value} download>
                                                    <i
                                                      style={{
                                                        fontSize: "25px",
                                                        paddingLeft: "8px",
                                                        textalign: "center",
                                                        verticalalign: "middle",
                                                      }}
                                                      className="bx bx-download"
                                                    ></i>
                                                  </a>
                                                ) : (
                                                  renderValue(value)
                                                )}
                                                {}
                                              </span>
                                            </Col>
                                          </Row>
                                        </>
                                      ) : null
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                            {sauvegardesAttestationData
                              ?.detail_sauvegardes_attestation?.[
                              "Transmission Entrepreteurs"
                            ] ? (
                              <Col sm="6">
                                <SouscriptionsCard
                                  title="Transmission Entrepreteurs"
                                  details={
                                    sauvegardesAttestationData
                                      ?.detail_sauvegardes_attestation?.[
                                      "Transmission Entrepreteurs"
                                    ]
                                  }
                                />
                              </Col>
                            ) : null}
                          </Row>

                          <Row>
                            {sauvegardesAttestationData
                              ?.detail_sauvegardes_attestation?.Audit ? (
                              <Col sm="12">
                                <SectionCard
                                  title="Audit"
                                  details={
                                    sauvegardesAttestationData
                                      ?.detail_sauvegardes_attestation?.Audit
                                  }
                                />
                              </Col>
                            ) : null}
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {/* Dossier SOuscriptions */}
                  {activeTab === "dossier" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <HmPaginated
                            title={dossierData}
                            data={dossierData.data}
                            header={dossierData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "rompus" && (
                    <div>
                      {!loading ? (
                        <>
                          <RompusHmList
                            title={rompusData}
                            data={rompusData.data}
                            header={rompusData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "souscriptions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <SouscriptionsHmListReservation
                            title={souscriptionsData}
                            data={souscriptionsData.data}
                            header={souscriptionsData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default DocumentFusion;
